import { usingGet } from '@ocean/api'
import { UserUtils } from 'utils'

export const getSystemInformation = () => usingGet('System/GetSystemInformation')

export const getCustomerInformation = (company?: string) => {
  const { customer } = UserUtils.getUserLoginParams()
  return usingGet(`System/GetCustomerInformation?customer=${company || customer}`)
}
